import { PublicApiClient } from "../../apiClient/publicApiClient";
import { RequestData } from "./types";

export const sendCaseClosureRequest = async (apiClient: PublicApiClient, data: RequestData) => {
    return apiClient.request("/servicecall/proactivecaseclosure", { body: data });
};
